var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6665 13.3333H16.6665C17.587 13.3333 18.3332 14.0795 18.3332 15V25C18.3332 25.9205 17.587 26.6667 16.6665 26.6667H11.6665V30H16.6665C19.4279 30 21.6665 27.7614 21.6665 25V21.6667H28.3332V18.3333H21.6665V15C21.6665 12.2386 19.4279 10 16.6665 10H11.6665V13.3333Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 11.668C3.3335 8.90654 5.57207 6.66797 8.3335 6.66797C11.0949 6.66797 13.3335 8.90654 13.3335 11.668C13.3335 14.4294 11.0949 16.668 8.3335 16.668C5.57207 16.668 3.3335 14.4294 3.3335 11.668ZM8.3335 10.0013C7.41302 10.0013 6.66683 10.7475 6.66683 11.668C6.66683 12.5884 7.41302 13.3346 8.3335 13.3346C9.25397 13.3346 10.0002 12.5884 10.0002 11.668C10.0002 10.7475 9.25397 10.0013 8.3335 10.0013ZM6.66683 28.3346C6.66683 29.2551 7.41302 30.0013 8.3335 30.0013C9.25397 30.0013 10.0002 29.2551 10.0002 28.3346C10.0002 27.4142 9.25397 26.668 8.3335 26.668C7.41302 26.668 6.66683 27.4142 6.66683 28.3346ZM8.3335 23.3346C5.57207 23.3346 3.3335 25.5732 3.3335 28.3346C3.3335 31.0961 5.57207 33.3346 8.3335 33.3346C11.0949 33.3346 13.3335 31.0961 13.3335 28.3346C13.3335 25.5732 11.0949 23.3346 8.3335 23.3346ZM31.6668 21.668C30.7464 21.668 30.0002 20.9218 30.0002 20.0013C30.0002 19.0808 30.7464 18.3346 31.6668 18.3346C32.5873 18.3346 33.3335 19.0808 33.3335 20.0013C33.3335 20.9218 32.5873 21.668 31.6668 21.668ZM26.6668 20.0013C26.6668 17.2399 28.9054 15.0013 31.6668 15.0013C34.4283 15.0013 36.6668 17.2399 36.6668 20.0013C36.6668 22.7627 34.4283 25.0013 31.6668 25.0013C28.9054 25.0013 26.6668 22.7627 26.6668 20.0013Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.5b617c15ca186d62d5504cc7d153db71.svg";
export { ForwardRef as ReactComponent };